module.exports = __webpack_public_path__ + "img/sat.8ac66d04.svg";